<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="rank-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 顶部搜索栏（折叠版） -->
        <div class="search-bar">
          <!-- 折叠/展开按钮 -->
          <el-button
            icon="el-icon-arrow-down"
            type="text"
            @click="toggleSearch"
            style="margin-right: 10px"
          >
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </el-button>

          <!-- 搜索项 -->
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="请输入用户ID"
              clearable
              style="width: 180px"
            ></el-input>
            <el-select
              v-model="searchParams.type"
              placeholder="业务类型"
              clearable
              style="width: 160px"
            >
              <el-option label="无限" :value="1"></el-option>
              <el-option label="擂台" :value="2"></el-option>
              <el-option label="闯关" :value="4"></el-option>
              <el-option label="爬塔" :value="8"></el-option>
              <el-option label="PK" :value="10"></el-option>
            </el-select>
            <!-- 新增 开始时间 -->
            <el-date-picker
              v-model="searchParams.start_at"
              type="datetime"
              placeholder="开始时间"
              style="width: 200px"
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
            <!-- 新增 结束时间 -->
            <el-date-picker
              v-model="searchParams.end_at"
              type="datetime"
              placeholder="结束时间"
              style="width: 200px"
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </div>

          <!-- 搜索/重置/列筛选 -->
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getRankList"
            >
              搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">
              重置
            </el-button>
            <el-popover
              placement="bottom"
              title="显示列筛选"
              trigger="click"
              width="220"
            >
              <el-checkbox-group v-model="checkedColumns">
                <el-checkbox
                  v-for="item in columnOptions"
                  :key="item.prop"
                  :label="item.prop"
                >{{ item.label }}</el-checkbox>
              </el-checkbox-group>
              <div style="text-align: right; margin-top: 8px">
                <el-button size="mini" @click="handleCheckAll">全选</el-button>
                <el-button size="mini" @click="handleClearAll">清空</el-button>
              </div>
              <el-button slot="reference" icon="el-icon-s-tools" type="info"
                >列筛选</el-button
              >
            </el-popover>
          </div>
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            label="排名"
            width="80"
            align="center"
            v-if="checkedColumns.includes('rank')"
          >
            <template slot-scope="scope">
              <span v-if="scope.$index + 1 === 1" style="color:#F56C6C;font-weight:bold">第{{ scope.$index + 1 }}名</span>
              <span v-else-if="scope.$index + 1 === 2" style="color:#E6A23C;font-weight:bold">第{{ scope.$index + 1 }}名</span>
              <span v-else-if="scope.$index + 1 === 3" style="color:#67C23A;font-weight:bold">第{{ scope.$index + 1 }}名</span>
              <span v-else>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="头像"
            width="80"
            align="center"
            v-if="checkedColumns.includes('avatar')"
          >
            <template slot-scope="scope">
              <el-avatar :src="scope.row.avatar" size="40"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="120"
            align="center"
            v-if="checkedColumns.includes('user_id')"
          />
          <el-table-column
            label="用户编号"
            prop="user_no"
            min-width="160"
            v-if="checkedColumns.includes('user_no')"
          />
          <el-table-column
            label="用户昵称"
            prop="nickname"
            min-width="180"
            v-if="checkedColumns.includes('nickname')"
          />
          <el-table-column
            label="消耗金额"
            prop="cost_price"
            width="140"
            align="center"
            v-if="checkedColumns.includes('cost_price')"
          >
            <template slot-scope="scope">
              ¥{{ scope.row.cost_price }}
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-rank-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 搜索 -->
        <div class="mobile-search-group">
          <el-button
            type="text"
            icon="el-icon-arrow-down"
            @click="toggleSearch"
            style="width: 100%; text-align: left; padding-left: 0"
          >
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </el-button>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            />
            <el-select
              v-model="searchParams.type"
              placeholder="业务类型"
              clearable
              size="medium"
            >
              <el-option label="无限" :value="1"></el-option>
              <el-option label="擂台" :value="2"></el-option>
              <el-option label="闯关" :value="4"></el-option>
              <el-option label="爬塔" :value="8"></el-option>
              <el-option label="PK" :value="10"></el-option>
            </el-select>
            <!-- 移动端开始时间 -->
            <el-date-picker
              v-model="searchParams.start_at"
              type="datetime"
              placeholder="开始时间"
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
            <!-- 移动端结束时间 -->
            <el-date-picker
              v-model="searchParams.end_at"
              type="datetime"
              placeholder="结束时间"
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </div>
        </div>
        <div style="display: flex; gap: 8px; margin-bottom: 10px">
          <el-button
            type="primary"
            plain
            round
            @click="getRankList"
            style="flex: 1"
          >搜索</el-button>
          <el-button plain round @click="resetSearch" style="flex: 1">重置</el-button>
        </div>

        <!-- 卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="(item, index) in tableData"
            :key="item.user_id"
          >
            <div class="card-header">
              <div style="display: flex; align-items: center; gap: 10px">
                <div class="rank-tag">
                  <span v-if="index + 1 === 1" class="tag-first">{{ index + 1 }}</span>
                  <span v-else-if="index + 1 === 2" class="tag-second">{{ index + 1 }}</span>
                  <span v-else-if="index + 1 === 3" class="tag-third">{{ index + 1 }}</span>
                  <span v-else class="tag-normal">{{ index + 1 }}</span>
                </div>
                <el-avatar :src="item.avatar" size="50"></el-avatar>
                <div class="info">
                  <div class="nickname">{{ item.nickname || "未知用户" }}</div>
                  <div class="uid">用户ID: {{ item.user_id }}</div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div>用户编号：{{ item.user_no }}</div>
              <div class="cost">消耗金额：¥{{ item.cost_price }}</div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            layout="total, prev, pager, next"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "LossFlowRank",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },

      // 主列表搜索参数
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
        type: "",
        start_at: "",
        end_at: "",
      },

      // 列筛选
      columnOptions: [
        { label: "排名", prop: "rank" },
        { label: "头像", prop: "avatar" },
        { label: "用户ID", prop: "user_id" },
        { label: "用户编号", prop: "user_no" },
        { label: "用户昵称", prop: "nickname" },
        { label: "消耗金额", prop: "cost_price" },
      ],
      checkedColumns: [
        "rank",
        "avatar",
        "user_id",
        "user_no",
        "nickname",
        "cost_price",
      ],

      searchCollapsed: true,
    };
  },
  // 删除dateRange监听，不再需要
  created() {
    this.getRankList();
  },
  methods: {
    // 获取排行榜列表
    async getRankList() {
      this.loading = true;
      try {
        const res = await api.loss.flowRank({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data || [];
          this.pageInfo.total = res.data.data.total || 0;
        }
      } finally {
        this.loading = false;
      }
    },

    // 重置搜索
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
        type: "",
        start_at: "",
        end_at: "",
      };
      this.getRankList();
    },

    // 分页切换
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getRankList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getRankList();
    },

    // 列筛选全选/清空
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },

    // 折叠搜索栏
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>

<style scoped>
/* PC样式 */
.rank-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 移动端样式 */
.mobile-rank-container {
  padding: 12px;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  margin-bottom: 10px;
}
.rank-tag {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: bold;
  font-size: 14px;
}
.tag-first {
  width: 32px;
  height: 32px;
  background: #F56C6C;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tag-second {
  width: 32px;
  height: 32px;
  background: #E6A23C;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tag-third {
  width: 32px;
  height: 32px;
  background: #67C23A;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tag-normal {
  width: 32px;
  height: 32px;
  background: #eee;
  color: #666;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info .nickname {
  font-size: 16px;
  font-weight: 500;
}
.info .uid {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.7;
}
.card-body .cost {
  font-size: 14px;
  color: #f56c6c;
  font-weight: 500;
  margin-top: 4px;
}
</style>

<style>
@media (max-width: 768px) {
  .pc-version {
    display: none !important;
  }
  .mobile-version {
    display: block !important;
  }
}
@media (min-width: 769px) {
  .pc-version {
    display: block !important;
  }
  .mobile-version {
    display: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/loss/flowRank.vue